
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as accountr2xE5PNXwJMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/account.vue?macro=true";
import { default as complete_45account6k24lK9ENTMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/complete-account.vue?macro=true";
import { default as forgot_45passwordHPg02Mfa5cMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/forgot-password.vue?macro=true";
import { default as homeAoUxfQ11eCMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/home.vue?macro=true";
import { default as indexUo7kjEB81VMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/index.vue?macro=true";
import { default as login2sZc2LtbrcMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/login.vue?macro=true";
import { default as notifications97WlQapYk2Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/notifications.vue?macro=true";
import { default as reset_45passwordk9DTnfl4QeMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/reset-password.vue?macro=true";
import { default as client_45filters2iERzxtWY5Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue?macro=true";
import { default as client_45groupsMVP9NxKTvaMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue?macro=true";
import { default as _91id_93mKayZSUFA3Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue?macro=true";
import { default as indexfzW7f10LgUMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue?macro=true";
import { default as _91id_938PINsKeK6CMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue?macro=true";
import { default as clientscDN73nvm4LMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue?macro=true";
import { default as delivery_45sheets8iNpVyxQrAMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue?macro=true";
import { default as indexrRudTJEe5WMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue?macro=true";
import { default as new69Rv0HWXXkMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue?macro=true";
import { default as exportjSpuwl4pylMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue?macro=true";
import { default as indexOXXOXXpTBVMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue?macro=true";
import { default as newOfNp2YikthMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue?macro=true";
import { default as _91id_93nIrFmDO0qVMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue?macro=true";
import { default as importqvUFV7VlYdMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue?macro=true";
import { default as indexh6MjB7Xw15Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue?macro=true";
import { default as createTHNd66ua77Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue?macro=true";
import { default as _91id_93kYY2hlSinHMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue?macro=true";
import { default as _91id_93OPz9u3pbvbMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue?macro=true";
import { default as indexBGsJKYHrYeMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue?macro=true";
import { default as inventoriesfNH5gpQkPkMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue?macro=true";
import { default as inventory3Gz4QUjiyaMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue?macro=true";
import { default as indexvpQJe6dDnSMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue?macro=true";
import { default as activity0KMXIgu4qqMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue?macro=true";
import { default as burndownYCAsFMnSyYMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue?macro=true";
import { default as indexdS0lwwFF8mMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue?macro=true";
import { default as reporting8jiDhFOWpsMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue?macro=true";
import { default as _91id_93d5xWoQN98fMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue?macro=true";
import { default as indexuM3pWAeBRgMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue?macro=true";
import { default as appointmentshfDc8tJxmXMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue?macro=true";
import { default as index1keRw0tdoqMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue?macro=true";
import { default as _91id_93uI8OzdYZUnMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue?macro=true";
import { default as client_45assignmentGzPtGnxORmMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue?macro=true";
import { default as client_45dashboardAqtaKbjiOBMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue?macro=true";
import { default as indexUwlY6BC7r5Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue?macro=true";
import { default as _91id_9359WcBf0oPkMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue?macro=true";
import { default as collaboratorsFftyjk9hh5Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue?macro=true";
import { default as indexWmzdfBXHkEMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue?macro=true";
import { default as roadmapiawQmmfVHBMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue?macro=true";
import { default as indexiM9RNy95emMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue?macro=true";
import { default as tasksRKZAa5TDSPMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue?macro=true";
import { default as rollout2RvLUueCF9Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue?macro=true";
import { default as schedule_45appointmenteFNzFS2G3hMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/schedule-appointment.vue?macro=true";
import { default as brandinguLZp5TnmUDMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/branding.vue?macro=true";
import { default as createvdngr9L1XgMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists/create.vue?macro=true";
import { default as _91id_93dde0vzk8mdMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists/edit/[id].vue?macro=true";
import { default as indexeOz5d9qZXZMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists/index.vue?macro=true";
import { default as checklistszDKmsgpK9MMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists.vue?macro=true";
import { default as client_45linkshgdg0CrboYMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/client-links.vue?macro=true";
import { default as custom_45fieldsSU7m6DTFgOMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/custom-fields.vue?macro=true";
import { default as index7WsiPuypWDMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsIiW9ijn7IOMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/integrations.vue?macro=true";
import { default as rolloutsmhGkn2MCJFMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/rollouts.vue?macro=true";
import { default as subscriptiongQXdGBjV48Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/subscription.vue?macro=true";
import { default as users05Iq1e8pUpMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/users.vue?macro=true";
import { default as createU7yLYj6SDGMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows/create.vue?macro=true";
import { default as _91id_93dABE5p4Nn2Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows/edit/[id].vue?macro=true";
import { default as indexviNnxb7LjYMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows/index.vue?macro=true";
import { default as workflowskUgO5XW3QdMeta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows.vue?macro=true";
import { default as settingskbm7XAHXV0Meta } from "/codebuild/output/src1392998611/src/packages/frontend/pages/settings.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: accountr2xE5PNXwJMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/account.vue")
  },
  {
    name: "complete-account",
    path: "/complete-account",
    meta: complete_45account6k24lK9ENTMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/complete-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordHPg02Mfa5cMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/forgot-password.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homeAoUxfQ11eCMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexUo7kjEB81VMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login2sZc2LtbrcMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notifications97WlQapYk2Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/notifications.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordk9DTnfl4QeMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/reset-password.vue")
  },
  {
    name: inventory3Gz4QUjiyaMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/inventory",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-filters",
    path: "client-filters",
    meta: client_45filters2iERzxtWY5Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-groups",
    path: "client-groups",
    meta: client_45groupsMVP9NxKTvaMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue")
  },
  {
    name: clientscDN73nvm4LMeta?.name,
    path: "clients",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-delivery-sheet-id",
    path: "delivery-sheet/:id()",
    meta: _91id_93mKayZSUFA3Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients",
    path: "",
    meta: indexfzW7f10LgUMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-view-id",
    path: "view/:id()",
    meta: _91id_938PINsKeK6CMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-delivery-sheets",
    path: "delivery-sheets",
    meta: delivery_45sheets8iNpVyxQrAMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue")
  },
  {
    name: exportjSpuwl4pylMeta?.name,
    path: "export",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-export",
    path: "",
    meta: indexrRudTJEe5WMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-export-new",
    path: "new",
    meta: new69Rv0HWXXkMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue")
  }
]
  },
  {
    name: importqvUFV7VlYdMeta?.name,
    path: "import",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-import",
    path: "",
    meta: indexOXXOXXpTBVMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-new",
    path: "new",
    meta: newOfNp2YikthMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-view-id",
    path: "view/:id()",
    meta: _91id_93nIrFmDO0qVMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory",
    path: "",
    meta: indexh6MjB7Xw15Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue")
  },
  {
    name: inventoriesfNH5gpQkPkMeta?.name,
    path: "inventories",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-create",
    path: "create",
    meta: createTHNd66ua77Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-dashboard-id",
    path: "dashboard/:id()",
    meta: _91id_93kYY2hlSinHMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-edit-id",
    path: "edit/:id()",
    meta: _91id_93OPz9u3pbvbMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories",
    path: "",
    meta: indexBGsJKYHrYeMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue")
  }
]
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-knowledge-base",
    path: "/rollout-project/:rolloutIdentifier()/knowledge-base",
    meta: indexvpQJe6dDnSMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue")
  },
  {
    name: reporting8jiDhFOWpsMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/reporting",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-reporting-activity",
    path: "activity",
    meta: activity0KMXIgu4qqMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting-burndown",
    path: "burndown",
    meta: burndownYCAsFMnSyYMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting",
    path: "",
    meta: indexdS0lwwFF8mMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue")
  }
]
  },
  {
    name: rollout2RvLUueCF9Meta?.name,
    path: "/rollout-project/:rolloutIdentifier()/rollout",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue"),
    children: [
  {
    name: appointmentshfDc8tJxmXMeta?.name,
    path: "appointments",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments-id",
    path: ":id()",
    meta: _91id_93d5xWoQN98fMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments",
    path: "",
    meta: indexuM3pWAeBRgMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue")
  }
]
  },
  {
    name: client_45assignmentGzPtGnxORmMeta?.name,
    path: "client-assignment",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment",
    path: "",
    meta: index1keRw0tdoqMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment-inventory-id",
    path: "inventory/:id()",
    meta: _91id_93uI8OzdYZUnMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-dashboard",
    path: "client-dashboard",
    meta: client_45dashboardAqtaKbjiOBMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue")
  },
  {
    name: collaboratorsFftyjk9hh5Meta?.name,
    path: "collaborators",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators",
    path: "",
    meta: indexUwlY6BC7r5Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators-profile-id",
    path: "profile/:id()",
    meta: _91id_9359WcBf0oPkMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout",
    path: "",
    meta: indexWmzdfBXHkEMeta || {},
    alias: ["/rollout-project/:rolloutIdentifier()"],
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-roadmap",
    path: "roadmap",
    meta: roadmapiawQmmfVHBMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue")
  },
  {
    name: tasksRKZAa5TDSPMeta?.name,
    path: "tasks",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-tasks",
    path: "",
    meta: indexiM9RNy95emMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue")
  }
]
  }
]
  },
  {
    name: "schedule-appointment",
    path: "/schedule-appointment",
    meta: schedule_45appointmenteFNzFS2G3hMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/schedule-appointment.vue")
  },
  {
    name: settingskbm7XAHXV0Meta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-branding",
    path: "branding",
    meta: brandinguLZp5TnmUDMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/branding.vue")
  },
  {
    name: checklistszDKmsgpK9MMeta?.name,
    path: "checklists",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists.vue"),
    children: [
  {
    name: "settings-checklists-create",
    path: "create",
    meta: createvdngr9L1XgMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists/create.vue")
  },
  {
    name: "settings-checklists-edit-id",
    path: "edit/:id()",
    meta: _91id_93dde0vzk8mdMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists/edit/[id].vue")
  },
  {
    name: "settings-checklists",
    path: "",
    meta: indexeOz5d9qZXZMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/checklists/index.vue")
  }
]
  },
  {
    name: "settings-client-links",
    path: "client-links",
    meta: client_45linkshgdg0CrboYMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/client-links.vue")
  },
  {
    name: "settings-custom-fields",
    path: "custom-fields",
    meta: custom_45fieldsSU7m6DTFgOMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/custom-fields.vue")
  },
  {
    name: "settings",
    path: "",
    meta: index7WsiPuypWDMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    meta: integrationsIiW9ijn7IOMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-rollouts",
    path: "rollouts",
    meta: rolloutsmhGkn2MCJFMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/rollouts.vue")
  },
  {
    name: "settings-subscription",
    path: "subscription",
    meta: subscriptiongQXdGBjV48Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/subscription.vue")
  },
  {
    name: "settings-users",
    path: "users",
    meta: users05Iq1e8pUpMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/users.vue")
  },
  {
    name: workflowskUgO5XW3QdMeta?.name,
    path: "workflows",
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows.vue"),
    children: [
  {
    name: "settings-workflows-create",
    path: "create",
    meta: createU7yLYj6SDGMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows/create.vue")
  },
  {
    name: "settings-workflows-edit-id",
    path: "edit/:id()",
    meta: _91id_93dABE5p4Nn2Meta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows/edit/[id].vue")
  },
  {
    name: "settings-workflows",
    path: "",
    meta: indexviNnxb7LjYMeta || {},
    component: () => import("/codebuild/output/src1392998611/src/packages/frontend/pages/settings/workflows/index.vue")
  }
]
  }
]
  }
]